module.exports = __webpack_public_path__ + "static/media/yanis.073ca618.png";